import type { FaireProductEntity } from "../../entity_types/product";

export const p_kmndq4wdx7: FaireProductEntity = {
  token: "p_kmndq4wdx7",
  type: "product",
  name: "Mesh Butterfly Long Pearl Rhinestone Tassel Earrings",
  brandToken: "b_nex9pcmkzj",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/46d82abf59cdd02ab632f8f5b9f9c03d0ca821e0a329c111ce964d6dd2133e2c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d2c56cb250dfd598ee6edf147488c69d0dfb390b44ceadd0b9303fcec996ff53.jpeg",
    "https://cdn.faire.com/fastly/41f128d56085aab356e50dd638d702ab96acb8b0a53aae54f189a56f1c9f23eb.jpeg",
  ],
  priceDollars: 8.82,
  description:
    "Material: gold tone metal, artificial pearl, rhinestone, acrylic \n size: 140mm * 50mm\n",
  tags: [],
  msrpDollars: 17.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:59.686Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
